<template>
  <div>
    <el-card shadow="always">
      <el-page-header v-if="id === ''" @back="back" title :content="$t('adicionar-novo-banco')"></el-page-header>
      <el-page-header v-if="id !== ''" @back="back" title :content="$t('atualizar-banco')"></el-page-header>
    </el-card>
    <el-card>
      <el-form :model="ruleForm" ref="ruleForm" label-position="top" :status-icon="true" :rules="rules"
        :inline-message="true">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item :label="$t('banco')" prop="bank">
              <el-select v-model="ruleForm.bank" placeholder="Select">
                <el-option label="Banco do Brasil" value="1"></el-option>
                <el-option label="Bradesco" value="2"></el-option>
                <el-option label="Caixa" value="3"></el-option>
                <el-option label="Itau" value="341"></el-option>
                <el-option label="Santander" value="5"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('beneficiario')" prop="name">
              <el-input ref="name" v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('cnpj')" prop="cnpj">
              <el-input v-model="ruleForm.federalid" v-mask="'NN.NNN.NNN/NNNN-##'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('carteira')" prop="wallet">
              <el-input v-model="ruleForm.wallet"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('agencia')" prop="branch" maxlength="5" size="5"
              v-mask="['###-#', '#####-#', '####-#']" class="is-required">
              <el-input maxlength="14" v-model="ruleForm.branch"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('conta')" prop="account" v-mask="[
              '###-#',
              '####-#',
              '#####-#',
              '######-#',
              '#######-#',
              '########-#',
            ]" class="is-required">
              <el-input maxlength="14" v-model="ruleForm.account"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('nosso-numero')" prop="mynumber" class="is-required" v-mask="[
              '###',
              '####',
              '#####',
              '######',
              '#######',
              '########',
              '#########',
            ]">
              <el-input maxlength="14" v-model="ruleForm.mynumber"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <br />
        <el-form-item style="text-align: center">
          <el-button type="warning" v-if="id === ''" autofocus @click="submitForm('ruleForm')">{{ $t("adicionar")
          }}</el-button>
          <el-button type="warning" v-if="id !== ''" autofocus @click="editForm('ruleForm')">{{ $t("atualizar")
          }}</el-button>
          <el-button type="danger" @click="back()">{{
            $t("voltar")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { i18n } from "@/plugin/i18n";
import { BankService } from "@/services/customers/bank.services";
import { UserService } from "@/services/users/user.services";

export default {
  name: "BankAdd",
  data() {
    var checkCpf = (rule, value, callback) => {
      const vm = this;
      if (vm.ruleForm.type === "2") {
        return callback();
      }
      CpfHelpers.checkCpf(rule, value, callback);
    };
    var checkCnpj = (rule, value, callback) => {
      const vm = this;
      if (vm.ruleForm.type === "1") {
        return callback();
      }
      CpfHelpers.checkCnpj(rule, value, callback);
    };
    return {
      id: "",
      user: {
        type: "2",
      },
      ruleForm: {
        federalid: "",
        bank: "001",
        name: "",
        wallet: "",
        branch: "",
        account: "",
        mynumber: "",
      },
      rules: {
        federalid: [
          {
            required: true,
            message: i18n.tc("cnpj-obrigatorio"),
            trigger: "blur",
          },
        ],
        bank: [
          {
            required: true,
            message: i18n.tc("banco-obrigatorio"),
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: i18n.tc("beneficiario-obrigatorio"),
            trigger: "blur",
          },
        ],
        wallet: [
          {
            required: true,
            message: i18n.tc("carteira-obrigatorio"),
            trigger: "blur",
          },
        ],
        branch: [
          {
            required: true,
            message: i18n.tc("agencia-obrigatorio"),
            trigger: "blur",
          },
        ],
        account: [
          {
            required: true,
            message: i18n.tc("conta-obrigatorio"),
            trigger: "blur",
          },
        ],
        mynumber: [
          {
            required: true,
            message: i18n.tc("nosso-numero-obrigatorio"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.push("/cadastro/banco").catch(() => { });
    },
    get() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      BankService.get(vm.id)
        .then((response) => {
          vm.ruleForm = response;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          BankService.add(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("banco-adicionado-sucesso"),
              });
              this.$refs[formName].resetFields();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          BankService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("banco-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        if (this.$route.params.id) {
          this.id = this.$route.params.id;
          vm.get();
        } else {
          vm.$refs.companyname.$el.children[0].focus();
        }
      })
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

form {
  margin-top: 20px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
